import axios from '@/services/axios'


const CreateProfile = async (productProfile, update) => {
	return new Promise((resolve, reject) => {
		axios('/productProfiles/', `${update ? 'PUT' : 'POST'}`, productProfile)
		.then((response) => {
			console.log("response-->", response)
			resolve(response)
		})
		.catch((error) => {
			reject(error)
		})
	})
}
export default CreateProfile
